"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionIndexScreen = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../../components");
var _utils = require("../../utils");
var _NoAppointmentsNotice = require("./NoAppointmentsNotice");
var _VideoChatCubbyContext = require("../../VideoChatCubbyContext");
var _SectionStatus = require("../SectionStatus");
var _VideoChatCubbyScreen;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var VideoChatCubbyScreenDescriptions = (_VideoChatCubbyScreen = {}, _defineProperty(_VideoChatCubbyScreen, _utils.VideoChatCubbyScreen.Patient, 'Patient’s profile, wellness factors, medical history, family history, allergies, and medications.'), _defineProperty(_VideoChatCubbyScreen, _utils.VideoChatCubbyScreen.Notes, 'Documentation of patient appointment and plan.'), _defineProperty(_VideoChatCubbyScreen, _utils.VideoChatCubbyScreen.Billing, 'Diagnostic code and patient’s place of service for billing.'), _defineProperty(_VideoChatCubbyScreen, _utils.VideoChatCubbyScreen.Prescriptions, 'Create new prescriptions and view past prescriptions.'), _VideoChatCubbyScreen);
var SectionRow = function SectionRow(_ref) {
  var type = _ref.type,
    status = _ref.status,
    onSelectSection = _ref.onSelectSection;
  return /*#__PURE__*/_react.default.createElement(_components.BaseButton, {
    className: "w-full pl-[24px] pr-[12px] py-[32px] flex items-center",
    onClick: function onClick() {
      return onSelectSection(type);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-[374px] text-left"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "tw-label-medium mb-[6px]"
  }, _utils.VideoChatCubbyScreenTitles[type]), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-sm-light"
  }, VideoChatCubbyScreenDescriptions[type]))), /*#__PURE__*/_react.default.createElement(_SectionStatus.SectionStatus, {
    className: "ml-[20px] flex-shrink-0",
    status: status
  }), /*#__PURE__*/_react.default.createElement(_components.Icon, {
    className: "ml-[20px] flex-shrink-0",
    type: "caret-right-medium-16"
  }));
};
var SectionIndexScreen = function SectionIndexScreen(_ref2) {
  var screens = _ref2.screens,
    onScheduleAppointment = _ref2.onScheduleAppointment;
  var _useVideoChatCubby = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    onGoToScreen = _useVideoChatCubby.onGoToScreen,
    sectionStatuses = _useVideoChatCubby.sectionStatuses,
    showNewApptNotice = _useVideoChatCubby.showNewApptNotice;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-section-index-screen h-full flex flex-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overflow-auto pt-[12px] divide-y divide-x-0 divide-solid divide-grey-20"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "px-[32px] py-[14px] tw-caption-regular text-grey-60"
  }, "Note section"), screens.map(function (screen) {
    return /*#__PURE__*/_react.default.createElement(SectionRow, {
      key: screen,
      type: screen,
      status: sectionStatuses[screen],
      onSelectSection: function onSelectSection() {
        return onGoToScreen(screen);
      }
    });
  })), showNewApptNotice && /*#__PURE__*/_react.default.createElement("div", {
    className: "p-[30px]"
  }, /*#__PURE__*/_react.default.createElement(_NoAppointmentsNotice.NoAppointmentsNotice, {
    onScheduleAppointment: onScheduleAppointment
  })));
};
exports.SectionIndexScreen = SectionIndexScreen;